import { render, staticRenderFns } from "./IndiaWorkshop.vue?vue&type=template&id=f863c90a&"
import script from "./IndiaWorkshop.vue?vue&type=script&lang=js&"
export * from "./IndiaWorkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports